import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'tx-paste-dialog',
  templateUrl: './paste-dialog.component.html',
  styleUrl: './paste-dialog.component.scss'
})
export class PasteDialogComponent {

  @Input() isMacOS: boolean = false;
  public imgSrc: string;

  constructor(public activeModal: NgbActiveModal) {
    this.imgSrc = this.getImageSrc();
  }

  @HostListener('document:paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const html = clipboardData.getData('text/html') || clipboardData.getData('text/plain');

    if (html) {
      this.activeModal.close(html);
    }
  }

  private getImageSrc() {
    const pasteButton = document.querySelector('#ribbonTabHome_btnPaste');
    if (pasteButton) {
      const defaultPasteButtonImage = pasteButton.querySelector('.ribbon-button-big-image');
      if (defaultPasteButtonImage) {
        const imgSrc = defaultPasteButtonImage.getAttribute('src') ?? '';

        return imgSrc;
      }
    }

    return '';
  }
}
